import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ValidatedResult } from '../../Models/Models/ValidatedResult';
import { DrawdownModel } from '../../Models/Models/QuoteAndApplyBase/Shared/DrawdownModel';

declare var IS_RUNNING_IN_APP_POOL;

export class DrawdownInstructionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(hierarchyId: string, model: DrawdownModel, isTakePensionBenefitsWizard: boolean, isEditRegulaerDrawdownWizard: boolean, isIllHealth: boolean): Promise<ValidatedResult<DrawdownModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Drawdown/DrawdownInstruction/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, model: model, isTakePensionBenefitsWizard: isTakePensionBenefitsWizard, isEditRegulaerDrawdownWizard: isEditRegulaerDrawdownWizard, isIllHealth: isIllHealth }

    return AjaxWrapper.post<ValidatedResult<DrawdownModel>, any>(url, data);
  }
}

